import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,InfiniteScroll,DotLoading,Footer,
  Button,Selector,Ellipsis,List,Avatar,NavBar,Tabs,SearchBar,Card,Grid,Image
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, LikeOutline,BellOutline,MessageFill,EditSOutline ,SmileOutline,GiftOutline} from 'antd-mobile-icons'

import { RightOutline } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import {
    PostNNShoppingOrders,GetPlanetProductPayRecords
} from '../../service/service';
import { environment } from '../../service/baseUrl';


const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            myShopping: [],
            totalCount: 0,
            page: 0,
            pageSize: 10,
            hasMore: true,
            loading: false,
            userInfo: {},
            initialLoading: false,
            activeKey: "0",

            typeShopping: [],
            typetotalCount: 0,
            typepage: 0,
            typepageSize: 10,
            typehasMore: true,
            typeloading: false,
            typeinitialLoading: false,
        };
    }

    componentDidMount() {
        var that = this;

        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            this.setState({
                id: id,
                initialLoading: true
            }, () => {
                this.loadPosts();
            });
        }
        
    }

    loadPosts = async () => {
        var that = this;
        const { page, pageSize, tabIdx, loading, hasMore, initialLoading } = this.state;
        if (!initialLoading && (loading || !hasMore)) return;

        this.setState({ loading: true });

        const data = {
            PlanetId: this.state.id,
            MaxResultCount: pageSize,
            SkipCount: page * pageSize,
            PayState: 2
        };

        try {
            PostNNShoppingOrders(data).then(res => {
                if (res.success) {
                    var newPosts = res.result.items || [];
                    newPosts.map(item => {
                        //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        if (item.headImg != null) {
                            if (item.headImg.indexOf("https://") > -1) {
                                var urls = item.headImg.split("https://").filter(Boolean);
                                item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                            }
                        }

                        if (item.productImgUrl != null && item.productImgUrl != "") {
                            item.productImgUrl = environment.apiEndpoint + "/NNFiles/Img/" + item.productImgUrl.split('/').pop()
                        }
                        if (item.productCoverPhoto != null && item.productCoverPhoto != "") {
                            item.productCoverPhoto = environment.apiEndpoint + "/NNFiles/Img/"
                                + item.productCoverPhoto.split('/').pop()
                        }
    
                        var str = "#点亮";
                        switch (item.productTypeId) {
                            case 487:
                                str = "#种植";
                                break;
                            case 489:
                                str = "#领养";
                                break;
                            case 490:
                                str = "#建设";
                                break;
                            case 499:
                                str = "#敬献";
                                break;
                            case 516:
                                str = "";
                                break;
                            case 497:
                            case 498:
                                str = "#点亮";
                                break;
                            default:
                                str = "#装饰";
                                break;
                        }
                        item.type = str;

                        const creationTime = new Date(item.creationTime); 
                        const now = new Date();
                        const timeDiff = now - creationTime; // 时间差（毫秒）
                        item.creationTime = that.formatTimeDifference(timeDiff);
                    })
                    const totalCount = res.result.totalCount || 0;
                    const currentHasMore = (page * pageSize) < totalCount;

                    that.setState({
                        myShopping: [...that.state.myShopping, ...newPosts],
                        totalCount: totalCount,
                        page: page + 1,
                        hasMore: currentHasMore,
                        initialLoading: false,
                        loading: false
                    });
                }
            })
        } catch (error) {
            console.error('加载留言失败:', error);
            this.setState({
                initialLoading: false, loading: false
            });
        }
    }

    typeloadPosts = async () => {
        var that = this;
        const { typepage, typepageSize, tabIdx, typeloading, typehasMore, typeinitialLoading } = this.state;
        if (!typeinitialLoading && (typeloading || !typehasMore)) return;

        this.setState({ typeloading: true });

        // const data = {
        //     PlanetId: this.state.id,
        //     MaxResultCount: typepageSize,
        //     SkipCount: typepage * typepageSize,
        // };

        try {
            GetPlanetProductPayRecords(this.state.id).then(res => {
                if (res.success) {
                    var newPosts = [];
                    res.result.filter(x => x.productTypeId != 516).map(item => {
                        if (item.productImgUrl != null && item.productImgUrl != "") {
                            item.productImgUrl = environment.apiEndpoint + "/NNFiles/Img/" + item.productImgUrl.split('/').pop()
                        }
                        if (item.productCoverPhoto != null && item.productCoverPhoto != "") {
                            item.productCoverPhoto = environment.apiEndpoint + "/NNFiles/Img/"
                                + item.productCoverPhoto.split('/').pop()
                        }
    
                        var str = "#点亮";
                        switch (item.productTypeId) {
                            case 487:
                                str = "#种植";
                                break;
                            case 489:
                                str = "#领养";
                                break;
                            case 490:
                                str = "#建设";
                                break;
                            case 499:
                                str = "#敬献";
                                break;
                            case 516:
                                str = "";
                                break;
                            case 497:
                            case 498:
                                str = "#点亮";
                                break;
                            default:
                                str = "#装饰";
                                break;
                        }
                        item.type = str;

                        const creationTime = new Date(item.creationTime); 
                        const now = new Date();
                        const timeDiff = now - creationTime; // 时间差（毫秒）
                        item.creationTime = that.formatTimeDifference(timeDiff);

                        const endDate = new Date(item.endDate); 
                        const timeDiff1 = endDate - now; // 时间差（毫秒）
                        item.endDate = that.formatTimeDifference1(timeDiff1, item.endDate);
                        newPosts.push(item);
                    })
                    // const totalCount = res.result.totalCount || 0;
                    // const currentHasMore = (typepage * typepageSize) < totalCount;

                    that.setState({
                        typeShopping: [...that.state.typeShopping, ...newPosts],
                        // typetotalCount: totalCount,
                        // typepage: typepage + 1,
                        // typehasMore: currentHasMore,
                        // typeinitialLoading: false,
                        // typeloading: false
                    });
                }
            })
        } catch (error) {
            console.error('加载留言失败:', error);
            this.setState({
                typeinitialLoading: false, typeloading: false
            });
        }
    }

    formatTimeDifference(diffInMs) {
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - diffInMs).toLocaleDateString("zh-CN");
        }
    }

    formatTimeDifference1(diffInMs, endDate) {
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "1分钟后";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟后`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时后`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天后`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(endDate).toLocaleDateString("zh-CN");
        }
    }

    render() {


        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto", backgroundColor: "#dadada" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'background-color': "#fff" }}>
                    礼物列表
                </NavBar>

                <div style={{ marginTop: "10px" }}>
                </div>

                <Tabs activeKey={this.state.activeKey} onChange={(key) => {
                    this.setState({
                        activeKey: key,
                    })

                    if (key == "1") {
                        this.typeloadPosts();
                    } else {
                        this.loadPosts();
                    }
                }}>
                    <Tabs.Tab title='礼物列表' key='0'>
                    </Tabs.Tab>
                    <Tabs.Tab title='礼物分类' key='1'>
                    </Tabs.Tab>
                </Tabs>

                {
                    this.state.activeKey == "0" ?
                        <div style={{ margin: "20px 10px 0px 10px" }}>

                            {
                                this.state.myShopping.map(item => {
                                    return (
                                        <>
                                            <Card>
                                                <div>
                                                    <Grid columns={5} gap={8}>
                                                        <Grid.Item span={1}>
                                                            <div style={{ margin: "12px 0px 6px 12px" }}>
                                                                <Avatar src={item.headImg}
                                                                    style={{ '--size': '48px', '--border-radius': '35px', 'margin': 'auto' }} />
                                                            </div>
                                                        </Grid.Item>
                                                        <Grid.Item span={4}>
                                                            <div style={{ height: "100%", paddingTop: "5%" }}>
                                                                <div style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                    {item.creatorUserName}
                                                                </div>
                                                                <div>
                                                                    {item.creationTime}
                                                                </div>
                                                            </div>
                                                        </Grid.Item>
                                                        <Grid.Item span={1}>

                                                        </Grid.Item>
                                                        <Grid.Item span={1}>
                                                            {
                                                                item.productTypeId != 516 ?
                                                                    <div>
                                                                        <Image src={item.productCoverPhoto}
                                                                            width={60} height={70} fit='cover'
                                                                            style={{ float: "right" }} />
                                                                    </div> : null
                                                            }
                                                        </Grid.Item>
                                                        <Grid.Item span={2}>
                                                            <div style={{ height: "100%", lineHeight: "65px", fontSize: "16px", marginBottom: "8%" }}>
                                                                <span style={{ fontWeight: "600" }}>
                                                                    {item.productName}
                                                                </span>
                                                                <span style={{ marginLeft: "10px", color: "#d67814" }}>
                                                                    {item.type}
                                                                </span>
                                                            </div>
                                                        </Grid.Item>
                                                    </Grid>
                                                </div>
                                            </Card>
                                            <div style={{ height: "10px" }}></div>
                                        </>)
                                })
                            }


                            {
                                this.state.page != 0 ?
                                    <InfiniteScroll
                                        loadMore={this.loadPosts}
                                        hasMore={this.state.hasMore}
                                        threshold={50}
                                        initialLoad={false}
                                    >
                                        {this.state.loading && (
                                            <div style={{ textAlign: 'center' }}>
                                                <DotLoading color="primary" />
                                                <span style={{ marginLeft: 8 }}>加载中...</span>
                                            </div>
                                        )}
                                        {!this.state.hasMore && (
                                            <div style={{ textAlign: 'center', color: '#999', marginBottom: "22%" }}>
                                                没有更多礼物了
                                </div>
                                        )}
                                    </InfiniteScroll> : null
                            }
                        </div> 
                        :

                        <div style={{ margin: "20px 10px 0px 10px" }}>

                            {
                                this.state.typeShopping.map(item => {
                                    if (item == undefined) {
                                        return;
                                    }
                                    return (
                                        <>
                                            <Card>
                                                <div>
                                                    <Grid columns={5} gap={8}>
                                                        <Grid.Item span={5}>
                                                            <div style={{ margin: "12px 0px 6px 12px" }}></div>
                                                        </Grid.Item>

                                                        {/* <Grid.Item span={1}>
                                                            <div style={{ margin: "12px 0px 6px 12px" }}>
                                                                <Avatar src={item.headImg}
                                                                    style={{ '--size': '48px', '--border-radius': '35px', 'margin': 'auto' }} />
                                                            </div>
                                                        </Grid.Item>
                                                        <Grid.Item span={4}>
                                                            <div style={{ height: "100%", paddingTop: "5%" }}>
                                                                <div style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                    {item.creatorUserName}
                                                                </div>
                                                                <div>
                                                                    {item.endDate}
                                                                </div>
                                                            </div>
                                                        </Grid.Item> */}
                                                        <Grid.Item span={1}>

                                                        </Grid.Item>
                                                        <Grid.Item span={1}>
                                                            {
                                                                item.productTypeId != 516 ?
                                                                    <div>
                                                                        <Image src={item.productCoverPhoto}
                                                                            width={60} height={70} fit='cover'
                                                                            style={{ float: "right", marginRight: "10px" }} />
                                                                    </div> : null
                                                            }
                                                        </Grid.Item>
                                                        <Grid.Item span={2}>
                                                            <div style={{
                                                                height: "100%", lineHeight: "65px",
                                                                fontSize: "16px", marginBottom: "8%"
                                                            }}>
                                                                <span style={{ fontWeight: "600" }}>
                                                                    {item.productName}
                                                                </span>
                                                                <span style={{ marginLeft: "10px", color: "#d67814" }}>
                                                                    {item.type}
                                                                </span>
                                                            </div>
                                                        </Grid.Item>
                                                        <Grid.Item span={4}>
                                                            <div style={{ textAlign: "end" }}>
                                                                礼物过期时间：
                                                            </div>
                                                        </Grid.Item>
                                                        <Grid.Item span={1}>
                                                            {item.endDate}
                                                        </Grid.Item>
                                                    </Grid>
                                                </div>
                                            </Card>
                                            <div style={{ height: "10px" }}></div>
                                        </>)
                                })
                            }

                            <div style={{ height: "10px", marginBottom: "22%" }}></div>

                            {/* {
                                this.state.typepage != 0 ?
                                    <InfiniteScroll
                                        loadMore={this.typeloadPosts}
                                        hasMore={this.state.typehasMore}
                                        threshold={50}
                                        initialLoad={false}
                                    >
                                        {this.state.typeloading && (
                                            <div style={{ textAlign: 'center' }}>
                                                <DotLoading color="primary" />
                                                <span style={{ marginLeft: 8 }}>加载中...</span>
                                            </div>
                                        )}
                                        {!this.state.typehasMore && (
                                            <div style={{ textAlign: 'center', color: '#999', marginBottom: "22%" }}>
                                                没有更多礼物了
                                </div>
                                        )}
                                    </InfiniteScroll> : null
                            } */}
                        </div>
                }

                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);